const baseURL3 = "https://friendserp.newfriendsjewellers.com:8085"; 

// const baseURL3 = "http://localhost:5000"; 



export default baseURL3;